import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseAllowProfessionalActivityOnTemplates = [
  {
    id: '-102001',
    language: Language.EN,
    subject: 'Lease contract update: Authorization to exercice a professional activity',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_ALLOW_PROFESSIONAL_ACTIVITY_ON,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerns: authorization to exercise a professional activity regarding the lease located at <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        {{#if (hasMultipleUnits lease)}}
        <p>We hereby authorize you to carry out a professional activity for the following rental unit(s): <strong>{{unitAddressList units}}</strong></p>
        {{else}}
        <p>We hereby authorize you to carry out a professional activity for the following rental unit: <strong>{{mainUnitName units}}</strong></p>
        {{/if}}
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-102002',
    language: Language.FR,
    subject: "Mise à jour du contrat de bail: Autorisation d'exercer une activité professionelle",
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_ALLOW_PROFESSIONAL_ACTIVITY_ON,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerne: autorisation d'exercer une activité professionnelle concernant le bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        {{#if (hasMultipleUnits lease)}}
        <p>Par la présente, nous vous autorisons désormais d'exercer une activité professionnelle pour l'/les unité(s) locative(s) suivante(s): <strong>{{unitAddressList units}}</strong></p>
        {{else}}
        <p>Par la présente, nous vous autorisons désormais d'exercer une activité professionnelle pour l'unité locative suivante: <strong>{{mainUnitName units}}</strong></p>
        {{/if}}
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-102003',
    language: Language.NL,
    subject: 'Update van het huurcontract: toestemming om een beroepsactiviteit uit te oefenen',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_ALLOW_PROFESSIONAL_ACTIVITY_ON,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreffende: toestemming om een beroepsactiviteit uit te oefenen met betrekking tot het huurcontract gelegen te <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        {{#if (hasMultipleUnits lease)}}
        <p>Hierbij geven wij u toestemming om een beroepsactiviteit uit te oefenen voor de volgende huureenheid/huureenheden: <strong>{{unitAddressList units}}</strong></p>
        {{else}}
        <p>Hierbij geven wij u toestemming om een beroepsactiviteit uit te oefenen voor de volgende huureenheid: <strong>{{mainUnitName units}}</strong></p>
        {{/if}}
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
      `,
  },
  {
    id: '-102004',
    language: Language.DE,
    subject: 'Mietvertragsupdate: Genehmigung zur Ausübung einer beruflichen Tätigkeit',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_ALLOW_PROFESSIONAL_ACTIVITY_ON,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreff: Genehmigung zur Ausübung einer beruflichen Tätigkeit bezüglich des Mietvertrags in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        {{#if (hasMultipleUnits lease)}}
        <p>Hiermit genehmigen wir Ihnen die Ausübung einer beruflichen Tätigkeit für die folgenden Mieteinheit(en): <strong>{{unitAddressList units}}</strong></p>
        {{else}}
        <p>Hiermit genehmigen wir Ihnen die Ausübung einer beruflichen Tätigkeit für die folgende Mieteinheit: <strong>{{mainUnitName units}}</strong></p>
        {{/if}}
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
